export const orderSupport = [
  {
    content: "Confirm your installation date.",
    src: "images/checkout-success/date.webp"
  },
  {
    content: "Inform you on how to apply for grant / finance if applicable. ",
    src: "images/checkout-success/subsidize.webp"
  },
  {
    content: "Answer any questions or queries you may have.",
    src: "images/checkout-success/support.webp"
  }
];
